import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '@services/auth.service';
import { Router } from '@angular/router';
import { AlertifyService } from '@services/alertify.service';
import { EmailDto } from '@models/email-dto';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'app-login-help',
  templateUrl: './login-help.component.html',
  styleUrls: ['./login-help.component.css']
})
export class LoginHelpComponent implements OnInit {
  loginHelpForm: FormGroup;
  emailDto: EmailDto;
  processing: boolean = false;
  emailSent: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authService: AuthService,
    private alertify: AlertifyService,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

  ngOnInit() {
    this.createLoginHelpForm();
  }

  createLoginHelpForm() {
    this.loginHelpForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  sendEmailResetPassword() {
    if (this.loginHelpForm.invalid) {
      return;
    }

    this.processing = true;
    this.emailSent = false;
    this.emailDto = Object.assign({}, this.loginHelpForm.value);
    
    this.authService.sendEmailResetPassword(this.emailDto).subscribe(next => {
      this.processing = false;
      this.emailSent = true;
      /*this.translate.get("RESET_PASSWORD_EMAIL_SENT").subscribe((text: string) => {
        this.alertify.success(text);
      });*/

      this.translate.get(["ALERTIFY.RESET_PASSWORD_EMAIL_SENT", "BOOTSTRAP.MODAL.INFO"]).subscribe((text: string) => {
        this.alertify.success(text['ALERTIFY.RESET_PASSWORD_EMAIL_SENT'])

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.INFO'],
          modal_body_html: text['ALERTIFY.RESET_PASSWORD_EMAIL_SENT'],
          modal_color_variant: "info"
        })
      });
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      this.processing = false;
      console.error(error)
      this.translate.get(["ALERTIFY.RESET_PASSWORD_EMAIL_SENT", "BOOTSTRAP.MODAL.INFO"]).subscribe((text: string) => {
        this.alertify.warning(text["ALERTIFY.RESET_PASSWORD_EMAIL_SENT"]);

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.INFO'],
          modal_body_html: text['ALERTIFY.RESET_PASSWORD_EMAIL_SENT'],
          modal_color_variant: "info"
        })
      });


    }, () => {
        // show another page
    }
    );

  }
}
